import { defineNuxtPlugin } from '#app/nuxt'
import { LazyAdminAnglerData, LazyAdminAnglerTable, LazyAdminDashboard, LazyAdminInvites, LazyAdminJudgesData, LazyAdminJudgesTable, LazyAdminNoPurchaseData, LazyAdminNoPurchaseTable, LazyAdminPendingData, LazyAdminPendingTable, LazyAdminRafflesCard, LazyAdminRafflesCardInformation, LazyAdminRafflesCardTopPattern, LazyAdminRafflesCartGenerator, LazyAdminRafflesDisplayItemCard, LazyAdminRafflesList, LazyAdminRafflesSelectWinners, LazyAdminRafflesViewPurchase, LazyAdminRaffles, LazyAdminRafflesStyle, LazyAdminRafflesData, LazyAdminRandomWinnersData, LazyAdminScoresData, LazyAdminScoresTable, LazyAdminSponsors, LazyAdminTable, LazyAdminTableData, LazyAdminTeamCreateModal, LazyAdminTeamData, LazyAdminTeamTable, LazyAdminWaitlist, LazyAlerts, LazyAnnouncementsCard, LazyAnnouncementsCreateComponent, LazyAnnouncementsList, LazyAnnouncements, LazyAuctionCreateItem, LazyAuctionDisplayItemCard, LazyAuctionItemCard, LazyAuctionItemEditModal, LazyAuctionItems, LazyAuctionWinnerModal, LazyBorrachoEditor, LazyCartActions, LazyCartShoppingBag, LazyCheckoutActions, LazyCheckoutAddressForm, LazyCheckoutCardInformation, LazyCheckoutPaymentSelect, LazyCheckoutShippingOptions, LazyCheckoutShoppingBag, LazyCommonButton, LazyCommonContainer, LazyCommonDataTable, LazyCommonDropdown, LazyCommonIndicator, LazyCommonLoadingPlaceholder, LazyCommonLogos, LazyCommonOverlay, LazyCommonPageHeader, LazyCommonPopup, LazyDarkToggle, LazyDashboardNavigation, LazyDashboardWelcomePage, LazyDisplayToolbar, LazyDocuseal, LazyDonateCardInformation, LazyDonateForm, LazyESign, LazyFooter, LazyGuestDocuseal, LazyGuestListTable, LazyHomeComingSoon, LazyIconsCart, LazyIconsDownload, LazyIconsLogo, LazyIconsLogoCircle, LazyIconsLogoHopescador, LazyIconsLogoSmall, LazyIconsPalm, LazyIconsStockMountain, LazyIconsUserCircle, LazyInviteJudge, LazyInvitePage, LazyJudgeRaffles, LazyJudgeScoring, LazyLeaderboardLeaderData, LazyLeaderboardLeaderTable, LazyLoginForm, LazyPreviewCode, LazyResetPasswordForm, LazyRulesMap, LazyRulesSection, LazyRules, LazySchedule, LazySignup, LazyTabs, LazyTeamCompanyPicture, LazyTeamDetails, LazyTextareaAutosize, LazyToolbar, LazyWelcomeSingleTeamForm, LazyWelcomeTeamCard, LazyWelcomeTeamForm, LazyWelcomeTeamSelectItem, LazyWelcomeTeamSelector, LazyWelcomeVendorForm, LazyMapboxAttributionControl, LazyMapboxCustomGeocoder, LazyMapboxDefaultMarker, LazyMapboxDefaultPopup, LazyMapboxFullscreenControl, LazyMapboxGeocoder, LazyMapboxGeolocateControl, LazyMapboxLayer, LazyMapboxMap, LazyMapboxNavigationControl, LazyMapboxScaleControl, LazyMapboxSource, LazyIcon, LazyIconCSS } from '#components'
const lazyGlobalComponents = [
  ["AdminAnglerData", LazyAdminAnglerData],
["AdminAnglerTable", LazyAdminAnglerTable],
["AdminDashboard", LazyAdminDashboard],
["AdminInvites", LazyAdminInvites],
["AdminJudgesData", LazyAdminJudgesData],
["AdminJudgesTable", LazyAdminJudgesTable],
["AdminNoPurchaseData", LazyAdminNoPurchaseData],
["AdminNoPurchaseTable", LazyAdminNoPurchaseTable],
["AdminPendingData", LazyAdminPendingData],
["AdminPendingTable", LazyAdminPendingTable],
["AdminRafflesCard", LazyAdminRafflesCard],
["AdminRafflesCardInformation", LazyAdminRafflesCardInformation],
["AdminRafflesCardTopPattern", LazyAdminRafflesCardTopPattern],
["AdminRafflesCartGenerator", LazyAdminRafflesCartGenerator],
["AdminRafflesDisplayItemCard", LazyAdminRafflesDisplayItemCard],
["AdminRafflesList", LazyAdminRafflesList],
["AdminRafflesSelectWinners", LazyAdminRafflesSelectWinners],
["AdminRafflesViewPurchase", LazyAdminRafflesViewPurchase],
["AdminRaffles", LazyAdminRaffles],
["AdminRafflesStyle", LazyAdminRafflesStyle],
["AdminRafflesData", LazyAdminRafflesData],
["AdminRandomWinnersData", LazyAdminRandomWinnersData],
["AdminScoresData", LazyAdminScoresData],
["AdminScoresTable", LazyAdminScoresTable],
["AdminSponsors", LazyAdminSponsors],
["AdminTable", LazyAdminTable],
["AdminTableData", LazyAdminTableData],
["AdminTeamCreateModal", LazyAdminTeamCreateModal],
["AdminTeamData", LazyAdminTeamData],
["AdminTeamTable", LazyAdminTeamTable],
["AdminWaitlist", LazyAdminWaitlist],
["Alerts", LazyAlerts],
["AnnouncementsCard", LazyAnnouncementsCard],
["AnnouncementsCreateComponent", LazyAnnouncementsCreateComponent],
["AnnouncementsList", LazyAnnouncementsList],
["Announcements", LazyAnnouncements],
["AuctionCreateItem", LazyAuctionCreateItem],
["AuctionDisplayItemCard", LazyAuctionDisplayItemCard],
["AuctionItemCard", LazyAuctionItemCard],
["AuctionItemEditModal", LazyAuctionItemEditModal],
["AuctionItems", LazyAuctionItems],
["AuctionWinnerModal", LazyAuctionWinnerModal],
["BorrachoEditor", LazyBorrachoEditor],
["CartActions", LazyCartActions],
["CartShoppingBag", LazyCartShoppingBag],
["CheckoutActions", LazyCheckoutActions],
["CheckoutAddressForm", LazyCheckoutAddressForm],
["CheckoutCardInformation", LazyCheckoutCardInformation],
["CheckoutPaymentSelect", LazyCheckoutPaymentSelect],
["CheckoutShippingOptions", LazyCheckoutShippingOptions],
["CheckoutShoppingBag", LazyCheckoutShoppingBag],
["CommonButton", LazyCommonButton],
["CommonContainer", LazyCommonContainer],
["CommonDataTable", LazyCommonDataTable],
["CommonDropdown", LazyCommonDropdown],
["CommonIndicator", LazyCommonIndicator],
["CommonLoadingPlaceholder", LazyCommonLoadingPlaceholder],
["CommonLogos", LazyCommonLogos],
["CommonOverlay", LazyCommonOverlay],
["CommonPageHeader", LazyCommonPageHeader],
["CommonPopup", LazyCommonPopup],
["DarkToggle", LazyDarkToggle],
["DashboardNavigation", LazyDashboardNavigation],
["DashboardWelcomePage", LazyDashboardWelcomePage],
["DisplayToolbar", LazyDisplayToolbar],
["Docuseal", LazyDocuseal],
["DonateCardInformation", LazyDonateCardInformation],
["DonateForm", LazyDonateForm],
["ESign", LazyESign],
["Footer", LazyFooter],
["GuestDocuseal", LazyGuestDocuseal],
["GuestListTable", LazyGuestListTable],
["HomeComingSoon", LazyHomeComingSoon],
["IconsCart", LazyIconsCart],
["IconsDownload", LazyIconsDownload],
["IconsLogo", LazyIconsLogo],
["IconsLogoCircle", LazyIconsLogoCircle],
["IconsLogoHopescador", LazyIconsLogoHopescador],
["IconsLogoSmall", LazyIconsLogoSmall],
["IconsPalm", LazyIconsPalm],
["IconsStockMountain", LazyIconsStockMountain],
["IconsUserCircle", LazyIconsUserCircle],
["InviteJudge", LazyInviteJudge],
["InvitePage", LazyInvitePage],
["JudgeRaffles", LazyJudgeRaffles],
["JudgeScoring", LazyJudgeScoring],
["LeaderboardLeaderData", LazyLeaderboardLeaderData],
["LeaderboardLeaderTable", LazyLeaderboardLeaderTable],
["LoginForm", LazyLoginForm],
["PreviewCode", LazyPreviewCode],
["ResetPasswordForm", LazyResetPasswordForm],
["RulesMap", LazyRulesMap],
["RulesSection", LazyRulesSection],
["Rules", LazyRules],
["Schedule", LazySchedule],
["Signup", LazySignup],
["Tabs", LazyTabs],
["TeamCompanyPicture", LazyTeamCompanyPicture],
["TeamDetails", LazyTeamDetails],
["TextareaAutosize", LazyTextareaAutosize],
["Toolbar", LazyToolbar],
["WelcomeSingleTeamForm", LazyWelcomeSingleTeamForm],
["WelcomeTeamCard", LazyWelcomeTeamCard],
["WelcomeTeamForm", LazyWelcomeTeamForm],
["WelcomeTeamSelectItem", LazyWelcomeTeamSelectItem],
["WelcomeTeamSelector", LazyWelcomeTeamSelector],
["WelcomeVendorForm", LazyWelcomeVendorForm],
["MapboxAttributionControl", LazyMapboxAttributionControl],
["MapboxCustomGeocoder", LazyMapboxCustomGeocoder],
["MapboxDefaultMarker", LazyMapboxDefaultMarker],
["MapboxDefaultPopup", LazyMapboxDefaultPopup],
["MapboxFullscreenControl", LazyMapboxFullscreenControl],
["MapboxGeocoder", LazyMapboxGeocoder],
["MapboxGeolocateControl", LazyMapboxGeolocateControl],
["MapboxLayer", LazyMapboxLayer],
["MapboxMap", LazyMapboxMap],
["MapboxNavigationControl", LazyMapboxNavigationControl],
["MapboxScaleControl", LazyMapboxScaleControl],
["MapboxSource", LazyMapboxSource],
["Icon", LazyIcon],
["IconCSS", LazyIconCSS],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
